import { render, staticRenderFns } from "./buildSubcontract.vue?vue&type=template&id=5aba24fc&scoped=true&"
import script from "./buildSubcontract.vue?vue&type=script&lang=js&"
export * from "./buildSubcontract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aba24fc",
  null
  
)

export default component.exports